export enum SPORTRADAR_NAMES {
  NFL_GAME_SUMMARY = 'us.match.nfl.summary',
  NFL_STANDINGS_SLIM = 'us.season.nfl.standingsSlim',
  COACHS_CORNER = 'us.match.nfl.coachesBooth',
  NFL_LEADERS = 'us.match.nfl.leaders',
  NHL_BOXSCORE = 'us.match.nhl.boxScore',
  NHL_STANDINGS_SLIM = 'us.season.nhl.standingsSlim',
  NHL_TEAM_STATS = 'us.match.nhl.teamStats',
  NHL_RECENT_GAMES = 'us.team.nhl.recentGames',
  NHL_RANKS = 'us.season.nhl.teamRanks',
  NHL_SCOREBOARD = 'us.match.scoreboard',
  NHL_GAME_TRACKER = 'us.match.nhl.gameTracker',
  NHL_PLAY_BY_PLAY = 'us.match.nhl.playByPlay',
  PITCHER_COMPARISON = 'us.season.mlb.pitcherComparison',
  MLB_SCOREBOARD = 'us.match.mlb.scoreboard',
  MLB_PLAY_BY_PLAY = 'us.match.mlb.playByPlay',
  MLB_STANDINGS_SLIM = 'us.season.mlb.standingsSlim',
  MLB_LINEUPS = 'us.match.mlb.lineups',
  MLB_BOXSCORE = 'us.match.mlb.boxscore',
  MLB_GAME_TRACKER = 'us.match.mlb.gameTracker',
  MLB_RECENT_GAMES = 'us.team.mlb.recentGames',
  NBA_SCOREBOARD = 'us.match.nba.scoreboard',
  NBA_COMPARISON = 'us.team.nba.comparison',
  NBA_STATISTICS = 'us.match.nba.statistics',
  NBA_TEAM_STATS = 'us.match.nba.teamStats',
  NBA_STANDINGS_SLIM = 'us.season.nba.standingsslim',
  NBA_RECENT_GAMES = 'us.team.nba.recentGames',
  NBA_BOXSCORE = 'us.match.nba.boxScore',
  NBA_PLAY_BY_PLAY = 'us.match.nba.playByPlay',
  NBA_LINESCORE = 'us.match.linescore',
  NBA_RANKS = 'us.season.nba.teamRanks',
  LEADERS = 'us.match.leaders',
  INJURIES = 'us.season.injuries',
  LIVE_MATCH_TRACKER = 'us.match.lmt',
  WIN_PROBABILITY = 'us.match.winProbability',
  TICKER = 'us.common.scoreTicker',
  ODDS = 'us.match.odds',
  BETTING_STATS = 'us.match.pregameBettingStatistics',
  TEAM_HEADER = 'us.team.header',
  TEAM_MATCH_SMALL = 'us.match.scoreSmall',
  NBA_TEAM_LEADERS = 'us.season.nba.teamleaders',
}

export const EXCLUDED_LIST = [
  'title',
  'dataId',
  'widgetId',
  'widget',
  'language',
];

export const NAME_TO_ID: any = {
  'us.match.nfl.summary': 'NFL_GAME_SUMMARY',
  'us.season.nfl.standingsSlim': 'NFL_STANDINGS_SLIM',
  'us.match.nfl.coachesBooth': 'COACHS_CORNER',
  'us.match.nfl.leaders': 'NFL_LEADERS',
  'us.match.nhl.boxScore': 'NHL_BOXSCORE',
  'us.season.nhl.standingsSlim': 'NHL_STANDINGS_SLIM',
  'us.match.nhl.teamStats': 'NHL_TEAM_STATS',
  'us.team.nhl.recentGames': 'NHL_RECENT_GAMES',
  'us.season.nhl.teamRanks': 'NHL_RANKS',
  'us.match.nhl.gameTracker': 'NHL_GAME_TRACKER',
  'us.match.nhl.playByPlay': 'NHL_PLAY_BY_PLAY',
  'us.match.scoreboard': 'NHL_SCOREBOARD',
  'us.season.mlb.pitcherComparison': 'PITCHER_COMPARISON',
  'us.match.mlb.scoreboard': 'MLB_SCOREBOARD',
  'us.match.mlb.playByPlay': 'MLB_PLAY_BY_PLAY',
  'us.match.mlb.lineups': 'MLB_LINEUPS',
  'us.season.mlb.standingsSlim': 'MLB_STANDINGS_SLIM',
  'us.match.mlb.boxscore': 'MLB_BOXSCORE',
  'us.match.mlb.gameTracker': 'MLB_GAME_TRACKER',
  'us.team.mlb.recentGames': 'MLB_RECENT_GAMES',
  'us.match.nba.scoreboard': 'NBA_SCOREBOARD',
  'us.match.nba.statistics': 'NBA_STATISTICS',
  'us.match.nba.teamStats': 'NBA_TEAM_STATS',
  'us.team.nba.comparison': 'NBA_COMPARISON',
  'us.season.nba.standingsslim': 'NBA_STANDINGS_SLIM',
  'us.team.nba.recentGames': 'NBA_RECENT_GAMES',
  'us.match.nba.boxScore': 'NBA_BOXSCORE',
  'us.match.nba.playByPlay': 'NBA_PLAY_BY_PLAY',
  'us.match.winProbability': 'WIN_PROBABILITY',
  'us.match.linescore': 'NBA_LINESCORE',
  'us.common.scoreTicker': 'TICKER',
  'us.match.pregameBettingStatistics': 'BETTING_STATS',
  'us.match.leaders': 'LEADERS',
  'us.season.injuries': 'INJURIES',
  'us.match.odds': 'ODDS',
  'us.match.lmt': 'LIVE_MATCH_TRACKER',
  'us.team.header': 'TEAM_HEADER',
  'us.match.scoreSmall': 'TEAM_MATCH_SMALL',
  'us.season.nba.teamleaders': 'NBA_TEAM_LEADERS',
  'us.season.nba.teamRanks': 'NBA_RANKS',
};

const {
  MLB_SCOREBOARD,
  NBA_SCOREBOARD,
  NBA_COMPARISON,
  NBA_STATISTICS,
  NBA_TEAM_STATS,
  NBA_STANDINGS_SLIM,
  LEADERS,
  NBA_BOXSCORE,
  NBA_PLAY_BY_PLAY,
  WIN_PROBABILITY,
  NBA_RECENT_GAMES,
  INJURIES,
  MLB_PLAY_BY_PLAY,
  LIVE_MATCH_TRACKER,
  ODDS,
  BETTING_STATS,
  MLB_STANDINGS_SLIM,
  MLB_BOXSCORE,
  MLB_GAME_TRACKER,
  MLB_LINEUPS,
  MLB_RECENT_GAMES,
  PITCHER_COMPARISON,
  NHL_SCOREBOARD,
  NHL_PLAY_BY_PLAY,
  NHL_GAME_TRACKER,
  NHL_RANKS,
  NHL_RECENT_GAMES,
  NHL_TEAM_STATS,
  NHL_STANDINGS_SLIM,
  NHL_BOXSCORE,
  // TEAM_HEADER,
  // NFL_LEADERS,
  // COACHS_CORNER,
  // NFL_STANDINGS_SLIM,
  // NFL_GAME_SUMMARY,
} = SPORTRADAR_NAMES;

export const SPORTRADAR_PROPS_MAPPING: Record<string, any> = {
  TEAM_HEADER: {
    teamUid: undefined,
    seasonId: undefined,
  },
  TEAM_MATCH_SMALL: {
    matchId: undefined,
  },
  TICKER: {
    nextDays: 2,
    layout: 'compact',
    oddsType: 'spread',
    showOdds: true,
    dayFlipHoursBefore: 3,
    linkGame: true,
    dayFlipUTCHours: 15,
    allowedSports: 'nba,mlb,nfl,soccer,nhl,wnba,ncaaf,ncaab',
    prevDays: 1,
    sport: undefined,
  },
  ODDS: {
    title: 'Game Odds',
    matchId: undefined,
    disableHeader: true,
  },
  BETTING_STATS: {
    title: 'Betting Stats',
    matchId: undefined,
  },
  LIVE_MATCH_TRACKER: {
    matchId: undefined,
    enableTeamColors: true,
  },
  LEADERS: {
    title: 'Team Leaders',
    matchId: undefined,
    enableTeamColors: true,
  },
  NBA_TEAM_LEADERS: {
    title: 'Team Leaders',
    uniqueTeamId: undefined,
    disableHeaderDetails: true,
    disableHeader: true,
    seasonId: undefined,
  },
  NBA_PLAY_BY_PLAY: {
    enableTeamColors: true,
    sortOrder: 'descending',
    matchId: undefined,
  },
  NBA_RECENT_GAMES: {
    teamTitle: true,
    title: 'Schedule',
    teamUid: undefined,
    currentSeason: true,
    pastGames: 10,
    disableTeamDropdown: true,
    disableHeader: true,
    nextGames: 3,
  },
  NBA_RANKS: {
    title: 'Team Rankings',
    teamUid: undefined,
    seasonId: undefined,
    disableHeader: true,
  },
  NBA_BOXSCORE: {
    enableTeamColors: true,
    matchId: undefined,
    enableSideBySideDisplay: true,
  },
  NBA_LINESCORE: {
    matchId: undefined,
    transformTeamId: true,
  },
  NBA_SCOREBOARD: {
    title: undefined,
    matchId: undefined,
    linkTeam: true,
  },
  WIN_PROBABILITY: {
    title: 'Win Probability',
    matchId: undefined,
    enableTeamColors: true,
  },
  NBA_STATISTICS: {
    title: 'Game Stats',
    matchId: undefined,
    disableMatchHeader: true,
    disableScoreboardTable: true,
    enableTeamColors: true,
    disableWidgetHeader: true,
  },
  NBA_TEAM_STATS: {
    title: 'Team Stats',
    enableTeamColors: true,
    matchId: undefined,
    disableHeader: true,
  },
  NBA_STANDINGS_SLIM: {
    teamTitle: true,
    title: 'Standings',
    uniqueTeamId: undefined,
    enableTeamColors: true,
    disableHeader: true,
    transformTeamId: true,
  },
  NBA_COMPARISON: {
    title: 'Team Comparison',
    enableTeamColors: true,
    disableWidgetHeader: true,
    disableTeamDropdown: true,
  },
  INJURIES: {
    teamTitle: true,
    title: 'Injuries',
    teamUid: undefined,
    seasonId: undefined,
    disableHeader: false,
    disableTeamHeaders: false,
  },
  MLB_SCOREBOARD: {
    title: undefined,
    matchId: undefined,
    linkTeam: true,
  },
  MLB_LINEUPS: {
    title: 'Lineups',
    matchId: undefined,
    enableTeamColors: true,
  },
  MLB_RECENT_GAMES: {
    teamTitle: true,
    title: 'Schedule',
    teamUid: undefined,
    currentSeason: true,
    pastGames: 10,
    nextGames: 3,
    disableTeamDropdown: true,
    disableHeader: true,
  },
  MLB_PLAY_BY_PLAY: {
    sortOrder: 'descending',
    enableTeamColors: true,
    matchId: undefined,
    disableInnerScrolling: true,
  },
  PITCHER_COMPARISON: {
    title: 'Pitcher Comparison',
    matchId: undefined,
    enableTeamColors: true,
  },
  MLB_STANDINGS_SLIM: {
    teamTitle: true,
    title: 'Standings',
    uniqueTeamId: undefined,
    enableTeamColors: true,
    disableHeader: true,
    transformTeamId: true,
  },
  MLB_BOXSCORE: {
    enableTeamColors: true,
    matchId: undefined,
    disableWidgetHeader: true,
    enableTeamTabs: true,
    enableSideBySideDisplay: true,
  },
  MLB_GAME_TRACKER: {
    title: 'Game Tracker',
    matchId: undefined,
    enableTeamColors: true,
  },
  NHL_SCOREBOARD: {
    title: undefined,
    matchId: undefined,
    linkTeam: true,
  },
  NHL_PLAY_BY_PLAY: {
    enableTeamColors: true,
    matchId: undefined,
    sortOrder: 'descending',
    disableInnerScrolling: true,
  },
  NHL_GAME_TRACKER: {
    title: 'Game Tracker',
    matchId: undefined,
    enableTeamColors: true,
  },
  NHL_RANKS: {
    teamTitle: true,
    title: 'Ranks',
    teamUid: undefined,
    seasonId: undefined,
    enableTeamColors: true,
  },
  NHL_RECENT_GAMES: {
    teamTitle: true,
    title: 'Schedule',
    teamUid: undefined,
    currentSeason: true,
    pastGames: 10,
    nextGames: 3,
    disableTeamDropdown: true,
    disableHeader: true,
  },
  NHL_TEAM_STATS: {
    title: 'Team Stats',
    enableTeamColors: true,
    matchId: undefined,
    disableHeader: true,
  },
  NHL_STANDINGS_SLIM: {
    teamTitle: true,
    title: 'Standings',
    uniqueTeamId: undefined,
    enableTeamColors: true,
    disableHeader: true,
    transformTeamId: true,
  },
  NHL_BOXSCORE: {
    enableTeamColors: true,
    matchId: undefined,
    disableWidgetHeader: true,
    enableTeamTabs: true,
    enableSideBySideDisplay: true,
  },
  NFL_LEADERS: {
    title: 'Team Leaders',
    matchId: undefined,
    enableTeamColors: true,
  },
  COACHS_CORNER: {
    title: "Coach's Corner",
    enableTeamSelect: true,
    disableWidgetHeader: true,
    matchId: undefined,
    teamColorsTheme: 'mono-team-colors-light',
    disableMatchHeader: true,
    useTeamColors: true,
  },
  NFL_GAME_SUMMARY: {
    title: 'Game Summary',
    matchId: undefined,
    enableTeamColors: true,
    enableTeamSelect: true,
    disableWidgetHeader: true,
    teamColorsTheme: 'mono-team-colors-light',
    disableMatchHeader: true,
    useTeamColors: true,
    league: 'nfl',
    seasonId: 2023,
  },
  NFL_STANDINGS_SLIM: {
    teamTitle: true,
    title: 'Standings',
    uniqueTeamId: undefined,
    enableTeamColors: true,
    disableHeader: true,
    transformTeamId: true,
  },
};

export const STANDARD_PROPS = {
  dataId: undefined,
  widgetId: undefined,
  border: false,
  language: 'en_us',
};

export const TEAM_PROPS = ['uniqueTeamId', 'teamUid', 'teamId'];

export const SPORTRADAR_MATCH_MAPPING: Record<string, any> = {
  nba: {
    future: {
      game: [
        NBA_SCOREBOARD,
        NBA_COMPARISON,
        INJURIES,
        INJURIES,
        WIN_PROBABILITY,
        NBA_RECENT_GAMES,
        NBA_RECENT_GAMES,
      ],
      betting: [NBA_SCOREBOARD, ODDS, BETTING_STATS, WIN_PROBABILITY],
    },
    inProgress: {
      game: [NBA_SCOREBOARD, LIVE_MATCH_TRACKER],
      playByPlay: [NBA_SCOREBOARD],
    },
    past: {
      game: [
        NBA_SCOREBOARD,
        NBA_STATISTICS,
        NBA_TEAM_STATS,
        LEADERS,
        NBA_STANDINGS_SLIM,
        NBA_STANDINGS_SLIM,
      ],
      recap: [NBA_SCOREBOARD, LEADERS, NBA_STANDINGS_SLIM, NBA_STANDINGS_SLIM],
      boxScore: [NBA_SCOREBOARD, NBA_BOXSCORE],
      playByPlay: [NBA_SCOREBOARD, NBA_PLAY_BY_PLAY],
    },
  },
  mlb: {
    future: {
      game: [
        MLB_SCOREBOARD,
        MLB_LINEUPS,
        INJURIES,
        INJURIES,
        WIN_PROBABILITY,
        PITCHER_COMPARISON,
        MLB_RECENT_GAMES,
        MLB_RECENT_GAMES,
      ],
      betting: [MLB_SCOREBOARD, ODDS, BETTING_STATS, WIN_PROBABILITY],
    },
    inProgress: {
      game: [MLB_SCOREBOARD, MLB_GAME_TRACKER, LIVE_MATCH_TRACKER],
      boxscore: [MLB_SCOREBOARD, MLB_BOXSCORE],
      playByPlay: [MLB_SCOREBOARD, MLB_PLAY_BY_PLAY],
    },
    past: {
      game: [
        MLB_SCOREBOARD,
        MLB_PLAY_BY_PLAY,
        MLB_STANDINGS_SLIM,
        MLB_STANDINGS_SLIM,
      ],
      boxscore: [MLB_SCOREBOARD, MLB_BOXSCORE],
      playByPlay: [MLB_SCOREBOARD, MLB_PLAY_BY_PLAY],
    },
  },
  nhl: {
    future: {
      game: [
        NHL_SCOREBOARD,
        LEADERS,
        NHL_RANKS,
        NHL_RANKS,
        INJURIES,
        INJURIES,
        WIN_PROBABILITY,
        NHL_RECENT_GAMES,
        NHL_RECENT_GAMES,
      ],
      betting: [NHL_SCOREBOARD, ODDS, BETTING_STATS, WIN_PROBABILITY],
    },
    inProgress: {
      game: [NHL_SCOREBOARD, NHL_GAME_TRACKER, LIVE_MATCH_TRACKER],
      playByPlay: [NHL_SCOREBOARD, NHL_PLAY_BY_PLAY],
    },
    past: {
      game: [
        NHL_SCOREBOARD,
        LEADERS,
        NHL_RANKS,
        NHL_RANKS,
        NHL_TEAM_STATS,
        NHL_STANDINGS_SLIM,
        NHL_STANDINGS_SLIM,
      ],
      recap: [NHL_SCOREBOARD],
      boxScore: [NHL_SCOREBOARD, NHL_BOXSCORE],
      playByPlay: [NHL_SCOREBOARD, NHL_PLAY_BY_PLAY],
    },
  },
  // nfl: {
  //   future: {
  //     game: [
  //       NFL_SCOREBOARD,
  //       LEADERS,
  //       NFL_RANKS,
  //       NFL_RANKS,
  //       INJURIES,
  //       INJURIES,
  //       WIN_PROBABILITY,
  //       NFL_RECENT_GAMES,
  //       NFL_RECENT_GAMES,
  //     ],
  //     betting: [NFL_SCOREBOARD, ODDS, BETTING_STATS, WIN_PROBABILITY],
  //   },
  //   inProgress: {
  //     game: [NFL_SCOREBOARD, NFL_GAME_TRACKER, LIVE_MATCH_TRACKER],
  //     playByPlay: [NFL_SCOREBOARD, NFL_PLAY_BY_PLAY],
  //   },
  //   past: {
  //     game: [
  //       NFL_SCOREBOARD,
  //       NFL_GAME_SUMMARY,
  //       LEADERS,
  //       COACHS_CORNER,
  //       NFL_STANDINGS_SLIM,
  //       NFL_STANDINGS_SLIM,
  //     ],
  //     recap: [NFL_SCOREBOARD],
  //     boxScore: [NFL_SCOREBOARD, NFL_BOXSCORE],
  //     playByPlay: [NFL_SCOREBOARD, NFL_PLAY_BY_PLAY],
  //   },
  // },
};
